import GateKeeperMiddleware from '@/middleware/GateKeeperMiddleware.js';

export default [
    {
        path: '/courses/:courseId/activities/:activityId',
        component: () => import('@/pages/courses/activities/ActivityPage.vue'),
        props: route => ({
            ...route.params,
            activityId: Number.parseInt(route.params.activityId, 10),
            courseId: Number.parseInt(route.params.courseId, 10),
        }),
        children: [
            {
                name: 'activity-view',
                path: '',
                component: () => import('@/components/activities/ActivityView.vue'),
                props: route => {
                    return {
                        ...route.params,
                        activityId: Number.parseInt(route.params.activityId, 10),
                        courseId: Number.parseInt(route.params.courseId, 10),
                    };
                },
                meta: {
                    title: 'Activities',
                    middleware: [GateKeeperMiddleware],
                    ability: ({ gateKeeper, to }) =>
                        gateKeeper.userHasAccessToCourse(to.params.courseId) ||
                        gateKeeper.userHasGroupPermissionWithinCourse(
                            to.params.courseId,
                            'view a remediation activity'
                        ),
                },
            },
        ],
    },
    {
        name: 'activity-submission',
        path: '/courses/:courseId/activities/:activityId/activity-submissions',
        component: () => import('@/pages/courses/activities/ActivityPage.vue'),
        meta: {
            title: 'Activities',
            middleware: [GateKeeperMiddleware],
            ability: ({ gateKeeper, to }) =>
                gateKeeper.userHasAccessToCourse(to.params.courseId) ||
                gateKeeper.userHasGroupPermissionWithinCourse(to.params.courseId, 'view a remediation activity'),
        },
        props: true,
    },
];
